import AppManagementRequest from './AppManagementRequest';
import { ComponentDependency } from './AppManagementModel';
//param @app : AppManagementModel
//param @createdBy: user profile from useIdentify()
//componentDependency : ComponentDependency
export default class ComponentDependencyRequest extends AppManagementRequest {
	constructor(app, createdBy, componentDependency = null) {
		super(app, createdBy);
		this.componentDependency =
			componentDependency ?? new ComponentDependency();
	}
}
